import { createContext } from 'react';

const CommentsContext = createContext(null);

export { CommentsContext };
